import React from 'react';
import { Icon } from '@chakra-ui/react'

function ExternalIcon({ icon, styling, onClick }) {
    return <Icon onClick={onClick} {...styling} as={icon} />
}

export default ExternalIcon;
